import i18next from "i18next";
import React from "react"

import { authOptions } from "site/rootWidget";
import { routeUpdaters } from "site/routes/routesState";

import { ButtonPrimary } from "utils/buttons";
import { DataLayer } from "utils/datalayer";
import { FormSkeletonLayout, formSkeletonConfig } from "utils/forms";
import { getClassName } from "utils/utils";

export const ThankYouUpdatePaymentLayout = () => {
    const title = i18next.language === "en" ? "Thanks!" : "Dankjewel!";
    const introText = i18next.language === "en" ? 
        "It worked! You have successfully added a new payment method to your account." :
        "Het is gelukt! Je hebt een nieuwe betaalmethode toegevoegd aan je account."
    
    const notice = i18next.language === "en" ? 
    "Please note: this change will not be visible immediately in your ‘Account details’. We still have to press some buttons behind the scenes, which could take a few days. Don’t worry, you will still have full access. And the payment for your subscription will continue as usual (your month might be a little longer than usual, those extra days are a gift from us)." :
    "Let op: dit zul je niet direct zien bij je ‘Accountgegevens’. Wij moeten achter de schermen nog wat knopjes omzetten, dit kan enkele dagen duren. Geen zorgen, je hebt gewoon volledige toegang. En de betaling voor je abonnement loopt gewoon door zoals gewoonlijk (je maand is hooguit wat langer dan normaal, dus dat je wat gratis dagen van ons cadeau krijgt)."
    
    const furtherQuestions = i18next.language === "en" ? "If you have any questions about this, feel free to send us a chat message!" : "Mocht je hier vragen over hebben: stuur ons een chatbericht!"

    return <FormSkeletonLayout type="trial-to-pro-success" kind="text-image" options={authOptions} isClrInverted={true} image={formSkeletonConfig.imageDark}>
        <header className={getClassName(authOptions, 'headerClassName', 'mb-4')}>
            <h1 className={getClassName(authOptions, 'titleClassName', 'mb-4')}>{title}</h1>
            <p className={getClassName(authOptions, 'introClassName', 'mb-4')}>{introText}</p>
            <p className={getClassName(authOptions, 'introClassName', 'mb-4')}>{notice}</p>
            <p className={getClassName(authOptions, 'introClassName', 'mb-4')}>{furtherQuestions}</p>
            <div style={{marginTop: '8px'}}>
                <ButtonPrimary
                kind="link"
                to={routeUpdaters(i18next.language).home.url}
                onClick={() => {DataLayer.headerButtonsClick(i18next.t('a11y:navigateHome'))}}
                size="s"
                label={i18next.t('a11y:navigateHome')}
                />
            </div>
        </header>
    </FormSkeletonLayout>
}